/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Betafull2Inputs */

const id_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Penuh`)
};

const ms_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Penuh`)
};

const da_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta er Fuld`)
};

const de_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta ist voll`)
};

const en_us2_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta is Full`)
};

const es_es2_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta llena`)
};

const es_mx2_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta llena`)
};

const fil_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puno na ang Beta`)
};

const fr_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La bêta est complète`)
};

const it_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta al completo`)
};

const hu_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Béta megtelt`)
};

const nl_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bèta is vol`)
};

const no_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta er full`)
};

const pl_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta jest pełna`)
};

const pt_br2_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta is Full`)
};

const pt_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta está cheia`)
};

const ro_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta este plină`)
};

const fi_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta on täynnä`)
};

const sv_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betan är full`)
};

const vi_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta đã đầy`)
};

const tr_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Dolu`)
};

const cs_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta je plná`)
};

const bg_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta е пълна`)
};

const ru_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бета-тест заполнен`)
};

const uk_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бета-версія заповнена`)
};

const ar_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدار التجريبي ممتلئ`)
};

const hi_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीटा भर गया`)
};

const th_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบต้าเต็มแล้ว`)
};

const ja_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベータ版は満員です`)
};

const zh_cn2_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta is Full`)
};

const zh_hant1_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta is Full`)
};

const ko_forms_androidbeta_betafull2 = /** @type {(inputs: Forms_Androidbeta_Betafull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta is Full`)
};

/**
* | output |
* | --- |
* | "Beta is Full" |
*
* @param {Forms_Androidbeta_Betafull2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_betafull2 = /** @type {((inputs?: Forms_Androidbeta_Betafull2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Betafull2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_betafull2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_betafull2(inputs)
	if (locale === "da") return da_forms_androidbeta_betafull2(inputs)
	if (locale === "de") return de_forms_androidbeta_betafull2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_betafull2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_betafull2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_betafull2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_betafull2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_betafull2(inputs)
	if (locale === "it") return it_forms_androidbeta_betafull2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_betafull2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_betafull2(inputs)
	if (locale === "no") return no_forms_androidbeta_betafull2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_betafull2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_betafull2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_betafull2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_betafull2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_betafull2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_betafull2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_betafull2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_betafull2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_betafull2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_betafull2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_betafull2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_betafull2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_betafull2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_betafull2(inputs)
	if (locale === "th") return th_forms_androidbeta_betafull2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_betafull2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_betafull2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_betafull2(inputs)
	return ko_forms_androidbeta_betafull2(inputs)
});
export { forms_androidbeta_betafull2 as "forms.androidBeta.betaFull" }